var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenstackPlansHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.52 13.36V14.08C4.52 14.64 4.97 15.08 5.53 15.08H14.47C15.03 15.08 15.48 14.64 15.48 14.08V13.36H20V17.74C20 18.76 19.16 19.6 18.14 19.6H1.86C0.84 19.6 0 18.76 0 17.74V13.36H4.52ZM4.52 7.56V12.08H0V7.56H4.52ZM20 7.56V12.08H15.48V7.56H20ZM18.14 0.4C19.16 0.4 20 1.24 20 2.26V6.28H15.48V5.56C15.48 5 15.03 4.56 14.47 4.56H5.52C4.96 4.56 4.52 5 4.52 5.56V6.28H0V2.26C0 1.24 0.84 0.4 1.86 0.4H18.14Z",
    fill: "url(#g1_osp_h)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1_osp_h",
    x1: 10,
    y1: 0.4,
    x2: 10,
    y2: 19.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4671F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenstackPlansHover);
export default __webpack_public_path__ + "static/media/openstack-plans-hover.d87c6f9d20ae8f2f6ce484ca48fb5ff2.svg";
export { ForwardRef as ReactComponent };